/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_Contact_SupportInputs */



/**
* | output |
* | --- |
* | "Please contact support for more information." |
*
* @param {Options_Api_Keys_Contact_SupportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_contact_support = /** @type {((inputs?: Options_Api_Keys_Contact_SupportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_Contact_SupportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez contacter le support pour plus d'informations.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Für weitere Informationen wenden Sie sich bitte an den Support.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Per ulteriori informazioni, contattare l'assistenza.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Для получения дополнительной информации обратитесь в службу поддержки.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comuníquese con el soporte para obtener más información.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请联系客服获取更多信息。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("詳細についてはサポートにお問い合わせください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अधिक जानकारी के लिए कृपया सहायता टीम से संपर्क करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Entre em contato com o suporte para obter mais informações.")
	return /** @type {LocalizedString} */ ("Please contact support for more information.")
});